import _regeneratorRuntime from "/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/regenerator";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { StatusCodes, TransportStatusError } from '@ledgerhq/hw-transport';
import { PublicKey } from '@solana/web3.js';
export function getDerivationPath(account, change) {
  var length = account !== undefined ? change === undefined ? 3 : 4 : 2;
  var derivationPath = Buffer.alloc(1 + length * 4);
  var offset = derivationPath.writeUInt8(length, 0);
  offset = derivationPath.writeUInt32BE(harden(44), offset); // Using BIP44

  offset = derivationPath.writeUInt32BE(harden(501), offset); // Solana's BIP44 path

  if (account !== undefined) {
    offset = derivationPath.writeUInt32BE(harden(account), offset);

    if (change !== undefined) {
      derivationPath.writeUInt32BE(harden(change), offset);
    }
  }

  return derivationPath;
}
var BIP32_HARDENED_BIT = 1 << 31 >>> 0;

function harden(n) {
  return (n | BIP32_HARDENED_BIT) >>> 0;
}

var INS_GET_PUBKEY = 0x05;
var INS_SIGN_MESSAGE = 0x06;
var P1_NON_CONFIRM = 0x00;
var P1_CONFIRM = 0x01;
var P2_EXTEND = 0x01;
var P2_MORE = 0x02;
var MAX_PAYLOAD = 255;
var LEDGER_CLA = 0xe0;
export function getPublicKey(transport, derivationPath) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var bytes;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return send(transport, INS_GET_PUBKEY, P1_NON_CONFIRM, derivationPath);

          case 2:
            bytes = _context.sent;
            return _context.abrupt("return", new PublicKey(bytes));

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
}
export function signTransaction(transport, transaction, derivationPath) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var paths, message, data;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            paths = Buffer.alloc(1);
            paths.writeUInt8(1, 0);
            message = transaction.serializeMessage();
            data = Buffer.concat([paths, derivationPath, message]);
            _context2.next = 6;
            return send(transport, INS_SIGN_MESSAGE, P1_CONFIRM, data);

          case 6:
            return _context2.abrupt("return", _context2.sent);

          case 7:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
}

function send(transport, instruction, p1, data) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    var p2, offset, _buffer, _response, buffer, response;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            p2 = 0;
            offset = 0;

            if (!(data.length > MAX_PAYLOAD)) {
              _context3.next = 14;
              break;
            }

          case 3:
            if (!(data.length - offset > MAX_PAYLOAD)) {
              _context3.next = 14;
              break;
            }

            _buffer = data.slice(offset, offset + MAX_PAYLOAD);
            _context3.next = 7;
            return transport.send(LEDGER_CLA, instruction, p1, p2 | P2_MORE, _buffer);

          case 7:
            _response = _context3.sent;

            if (!(_response.length !== 2)) {
              _context3.next = 10;
              break;
            }

            throw new TransportStatusError(StatusCodes.INCORRECT_DATA);

          case 10:
            p2 |= P2_EXTEND;
            offset += MAX_PAYLOAD;
            _context3.next = 3;
            break;

          case 14:
            buffer = data.slice(offset);
            _context3.next = 17;
            return transport.send(LEDGER_CLA, instruction, p1, p2, buffer);

          case 17:
            response = _context3.sent;
            return _context3.abrupt("return", response.slice(0, response.length - 2));

          case 19:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
}